import { asMarkdownTemplate } from '../../../webmodule-common/other/general/markdown';
import { getCurrentUser } from '../../../webmodule-common/other/api/current-user';
import { html, TemplateResult } from 'lit';
import { information } from '../../../webmodule-common/other/ui/modal-option';
import { isEmptyOrSpace } from '../../../webmodule-common/other/ui/string-helper-functions';
import { LitBaseModal } from '../../../webmodule-common/other/ui/modal/modal-factory-lit';
import { LangQuoteTechnicalReviewConfirmation } from '../../../localization/scripts/quotes/quote-technical-review-confirmation-lang';

export enum QuoteTechnicalReviewQuery {}
export class QuoteTechnicalReviewDialog extends LitBaseModal {
  poNumberRequired = false;
  forceIssueOrder = false;
  supplierName: string;
  orderNumber = '';
  allowSupplierToIssue = false;
  ok = false;
  constructor(poNumberRequired: boolean, forceIssueOrder: boolean, supplierName: string, orderNumber: string) {
    super();
    this.poNumberRequired = poNumberRequired;
    this.forceIssueOrder = forceIssueOrder;
    this.supplierName = supplierName;
    this.orderNumber = orderNumber;
  }

  private async validateNumber() {
    if (this.poNumberRequired && isEmptyOrSpace(this.orderNumber)) {
      const user = getCurrentUser();
      const dealerName = (user as any).tenantName ?? LangQuoteTechnicalReviewConfirmation.franchisee();

      await information(LangQuoteTechnicalReviewConfirmation.orderNumberRequired({ dealerName }));
      return false;
    }
    return true;
  }
  private yesEvent = async () => {
    if (!(await this.validateNumber())) {
      return;
    }
    this.allowSupplierToIssue = true;
    this.ok = true;
    this.hideModal();
  };
  private noEvent = async () => {
    if (!(await this.validateNumber())) {
      return;
    }
    this.ok = true;
    this.hideModal();
  };
  private cancelEvent = async () => {
    this.ok = false;
    this.hideModal();
  };

  async canClose() {
    return true;
  }
  footerTemplate(): TemplateResult | null | undefined {
    return this.forceIssueOrder
      ? html` <webmodule-button variant="default" @click=${this.cancelEvent}
            >${LangQuoteTechnicalReviewConfirmation.cancelButton()}</webmodule-button
          >
          <webmodule-button variant="primary" @click=${this.yesEvent}
            >${LangQuoteTechnicalReviewConfirmation.sendButton()}</webmodule-button
          >`
      : html` <webmodule-button variant="default" @click=${this.cancelEvent}
            >${LangQuoteTechnicalReviewConfirmation.cancelButton()}</webmodule-button
          >
          <webmodule-button variant="default" @click=${this.noEvent}
            >${LangQuoteTechnicalReviewConfirmation.noThanksButton()}</webmodule-button
          >
          <webmodule-button variant="primary" @click=${this.yesEvent}
            >${LangQuoteTechnicalReviewConfirmation.yesButton()}</webmodule-button
          >`;
  }
  get isFooterVisible(): boolean {
    return true;
  }
  private eventPO = (e: Event) => {
    this.orderNumber = (e.currentTarget as HTMLInputElement).value;
  };

  title(): string | TemplateResult {
    return LangQuoteTechnicalReviewConfirmation.technicalReviewTitle();
  }
  bodyTemplate(): TemplateResult {
    const user = getCurrentUser();
    const mandatory = this.poNumberRequired ? html`<span class="text-danger "><sup>*</sup></span>` : html``;
    const dealerName = (user as any).tenantName ?? LangQuoteTechnicalReviewConfirmation.franchisee();
    const verbage = this.forceIssueOrder
      ? LangQuoteTechnicalReviewConfirmation.technicalReviewDirectToSupplier({ supplierName: this.supplierName })
      : LangQuoteTechnicalReviewConfirmation.technicalReviewWithApproval({ supplierName: this.supplierName });
    return html`<div class="me-2">${asMarkdownTemplate(verbage, true)}</div>
      <div>
        <label>${LangQuoteTechnicalReviewConfirmation.dealerOrderNoLabel({ dealerName })} ${mandatory}</label
        ><input
          id="ponumber"
          type="text"
          maxlength="200"
          .value=${this.orderNumber}
          @changed=${this.eventPO}
          @blur=${this.eventPO}
        />
      </div>`;
  }
}
